import Cookies from 'js-cookie'

let DonationPopup = function( options ) {
    this.options = Object.assign( {}, DonationPopup.defaultOptions, options );
    
    this.timeout;
    this.timesSeen = 0;
    this.previousState;

    this.popup = document.querySelector( '.donationpopup' );

    if ( !this.popup || this.popup.classList.contains( 'donationpopup--initialised' ) ) {
        return;
    }

    const userHasDonated = Cookies.get( 'bchc__lastDonationDate' );

    if ( userHasDonated ) {
        return;
    }

    const userHasSeenPopup = Cookies.get( 'bchc__donationPopupSeen' );

    if ( userHasSeenPopup ) {
        return;
    }

    for ( let i = 0; i < this.options.denyURLs.length; i++ ) {
        const urlToTest = this.options.denyURLs[ i ];

        const pattern = new RegExp( urlToTest, );

        if ( pattern.test( window.location.href ) ) {
            return;
        }
    }

    const hasValidDisplayConfig = (
        this.options.minPageViews > 0 ||
        ( this.options.useTimer && this.options.timerDurationInSeconds > 0 )
    );

    if ( !this.options.enabled || !hasValidDisplayConfig ) {
        return;
    }

    this.previousState = this.getState();

    this.state = Object.assign( {}, this.previousState, {
        pageViews: this.previousState.pageViews + 1,
    } );

    this.updateState( this.state );

    this.init();
}

DonationPopup.prototype.init = function() {
    const useTimer = ( this.options.useTimer && this.options.timerDurationInSeconds > 0 );

    if ( useTimer ) {
        this.timeout = window.setTimeout( this.show.bind( this ), this.options.timerDurationInSeconds * 1000 );
    }

    if ( !useTimer && this.state.pageViews >= this.options.minPageViews ) {
        window.setTimeout( this.show.bind( this ), 500 );
    }

    this.popup.classList.add( 'donationpopup--initialised' );
};

DonationPopup.prototype.show = function() {
    $.magnificPopup.open( {
        items: {
          src: '.donationpopup',
          type: 'inline',
        },
        callbacks: {
            open: () => {
                this.open();
            }
        },
        closeOnBgClick: false,
        showCloseBtn: true,
        closeOnContentClick: false,
        enableEscapeKey: false,
        fixedContentPos: true,
    } );
};

DonationPopup.prototype.open = function() {
    this.timesSeen++;

    this.state = Object.assign( {}, this.previousState, {
        timesSeen: this.timesSeen,
    } );

    this.updateState( this.state );

    const now = new Date();

    const currentDate = `${now.getUTCDay()}/${now.getUTCMonth()}/${now.getUTCFullYear()}`;

    Cookies.set( 'bchc__donationPopupSeen', currentDate, {
        secure: true,
        expires: this.options.cookieExpirationInDays,
    } );
};

DonationPopup.prototype.getState = function() {
    const previousStateJSON = window.sessionStorage.getItem( 'donationPopupState' ) || '';

    if ( previousStateJSON.length > 0 ) {
        return JSON.parse( previousStateJSON );
    } 

    return DonationPopup.defaultState;
}

DonationPopup.prototype.updateState = function( state ) {
    window.sessionStorage.setItem( 'donationPopupState', JSON.stringify( state ) );
}

DonationPopup.defaultState = {
    pageViews: 0,
};

DonationPopup.defaultOptions = {
    enabled: false,
    minPageViews: 0,
    timerDurationInSeconds: 0,
    useTimer: false,
    cookieExpirationInDays: 365,
    denyURLs: []
};

export default DonationPopup;
